/** Blog posts, newest first. The list lives here, not in the post modules,
 * so /blog and "read also" links don't load every post. Each post's page is
 * src/site/pages/blog/<slug>.tsx with the same path. */
export interface BlogPost {
  path: string
  title: string
  description: string
  /** YYYY-MM-DD */
  published: string
  minutes: number
}

export const BLOG_POSTS: BlogPost[] = [
  {
    path: '/blog/yak-ne-vtrachaty-dzvinky-pislya-18',
    title: 'Як не втрачати дзвінки після 18:00',
    description:
      'Чому вечірні дзвінки найдорожчі, які є способи на них відповідати і як налаштувати так, щоб зранку на вас чекали заявки, а не пропущені.',
    published: '2026-10-28',
    minutes: 6,
  },
  {
    path: '/blog/ai-agent-chy-administrator',
    title: 'AI-агент чи адміністратор: що вигідніше малому бізнесу',
    description:
      'Чесне порівняння: що AI-агент робить краще за людину, де без людини не обійтися і як порахувати вигоду на своїх цифрах.',
    published: '2026-10-28',
    minutes: 7,
  },
  {
    path: '/blog/skilky-dzvinkiv-vy-propuskayete',
    title: 'Як перевірити, скільки дзвінків ви пропускаєте',
    description:
      'Покрокова перевірка за тиждень: де взяти дані про пропущені дзвінки, як їх порахувати і що з цим робити далі.',
    published: '2026-10-28',
    minutes: 6,
  },
]

export function formatDate(iso: string): string {
  const months = [
    'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
    'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня',
  ]
  const [y, m, d] = iso.split('-').map(Number)
  return `${d} ${months[m - 1]} ${y}`
}
